module.exports = __webpack_public_path__ + "static/media/POPCORN_2.b7e46b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/POPCORN_2.png
// module id = 185
// module chunks = 0